import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { RouteConfigLoadEnd, RouteConfigLoadStart, Router } from '@angular/router';
import { takeUntil } from 'rxjs';

import { RxntPopupConfigService, RxntSubscribeControl } from '@rxnt/angular-components/core';
import {
  RxntDevextremeLicenseService,
} from '@rxnt/angular-components/dx-license';

import { MenuItem } from 'projects/rxnt/angular-components/src/lib/rxnt-menu/menu-item.model';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AppComponent extends RxntSubscribeControl implements OnInit {
  menuItems: MenuItem[] = [];
  routeLoading: boolean = false;

  constructor(
    private router: Router,
    private ref: ChangeDetectorRef,
    private dxLicenseService: RxntDevextremeLicenseService,
    private popupConfigService: RxntPopupConfigService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.dxLicenseService.setLicense();
    this.popupConfigService.setGlobalPopupSelectors([ '.popuptext' ]);

    this.menuItems = this.createMenuItems();
    this.subscribeToRouterEvents();
  }

  menuClickHandler($event: MenuItem): void {
    this.router.navigateByUrl($event.routePath);
  }

  private subscribeToRouterEvents(): void {
    // Victor: display progress for lazy loaded modules
    this.router.events.pipe(takeUntil(this.destroy$)).subscribe((
      event => {
        if (event instanceof RouteConfigLoadStart) {
          this.routeLoading = true;
          this.ref.markForCheck();
        }
        if (event instanceof RouteConfigLoadEnd) {
          this.routeLoading = false;
          this.ref.markForCheck();
        }
      }));
  }

  // noinspection JSMethodCanBeStatic
  private createMenuItems(): MenuItem[] {
    return [
      {
        text: 'Home',
        icon: 'home',
        routePath: '/',
      },
      {
        text: 'Button',
        icon: '',
        routePath: '/button',
      },
      {
        text: 'Pill',
        icon: '',
        routePath: '/pill',
      },
      {
        text: 'Error Handling',
        icon: '',
        routePath: '/error-handling',
      },
      {
        text: 'Error Icon',
        icon: '',
        routePath: '/error-icon',
      },
      {
        text: 'Loading spinner',
        icon: '',
        routePath: '/loading-spinner',
      },
      {
        text: 'Progress bar',
        icon: '',
        routePath: '/progress-bar',
      },
      {
        text: 'Utility Grid',
        icon: '',
        routePath: '/util-grid',
      },
      {
        text: 'Card',
        icon: '',
        routePath: '/card',
      },
      {
        text: 'Input',
        icon: '',
        routePath: '/input',
      },
      {
        text: 'Input Area',
        icon: '',
        routePath: '/input-area',
      },
      {
        text: 'Input Color',
        icon: '',
        routePath: '/input-color',
      },
      {
        text: 'Input Tooltips',
        icon: '',
        routePath: '/input-tooltips',
      },
      {
        text: 'Typeahead',
        icon: '',
        routePath: '/typeahead',
      },
      {
        text: 'Datepicker',
        icon: '',
        routePath: '/datepicker',
      },
      {
        text: 'Dropdown',
        icon: '',
        routePath: '/dropdown',
      },
      {
        text: 'Multiselect',
        icon: '',
        routePath: '/multiselect',
      },
      {
        text: 'Validations',
        icon: '',
        routePath: '/validations',
      },
      {
        text: 'Popup',
        icon: '',
        routePath: '/popup',
      },
      {
        text: 'Popup Service',
        icon: '',
        routePath: '/popup-service',
      },
      {
        text: 'Radio Group',
        icon: '',
        routePath: '/radio-group',
      },
      {
        text: 'Checkbox',
        icon: '',
        routePath: '/checkbox',
      },
      {
        text: 'Toggle',
        icon: '',
        routePath: '/toggle',
      },
      {
        text: 'Pie Chart',
        icon: '',
        routePath: '/pie-chart',
      },
      {
        text: 'Stepper',
        icon: '',
        routePath: '/stepper',
      },
      {
        text: 'Kanban Board',
        icon: '',
        routePath: '/kanban-board',
      },
      {
        text: 'Scheduler',
        icon: '',
        routePath: '/scheduler',
      },
      {
        text: 'Toast / Notify',
        icon: '',
        routePath: '/toast',
      },
      {
        text: 'File Upload',
        icon: '',
        routePath: '/file-upload',
      },
      {
        text: 'Form Array',
        icon: '',
        routePath: '/form-array',
      },
      {
        text: 'Dynamic Form',
        icon: '',
        routePath: '/dynamic-form',
      },
      {
        text: 'Dynamic',
        icon: '',
        routePath: '/dynamic',
      },
    ];
  }
}
